import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import './Auth.css';

import { authApi } from '../api/auth';

export function Login() {
    const { t, language } = useLanguage();
    const isRtl = language === 'ar';
    const navigate = useNavigate();
    const [formData, setFormData] = useState({ email: '', password: '' });
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    // ── THE BROWSER BACK-BUTTON SLAYER (LOGIN) ──
    useEffect(() => {
        const enforceLoginRedirect = () => {
            const token = localStorage.getItem('token') || localStorage.getItem('auth_token');
            const isAdmin = localStorage.getItem('isAdmin');
            // If they are already logged in and hit the BACK arrow to get here, bounce them back to Admin
            if (token && isAdmin === 'true') {
                window.location.replace('/admin');
            }
        };

        enforceLoginRedirect();
        window.addEventListener('popstate', enforceLoginRedirect);

        return () => {
            window.removeEventListener('popstate', enforceLoginRedirect);
        };
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError('');
        
        try {
            const cleanPayload = {
                ...formData,
                email: formData.email.replace(/\s/g, '')
            };

            const response = await authApi.login(cleanPayload);
            
            if (response.accessToken) {
                localStorage.setItem('token', response.accessToken);
                localStorage.setItem('auth_token', response.accessToken); 
            }
            
            const payload = JSON.parse(atob(response.accessToken.split('.')[1]));
            const role = payload['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
            
            if (role === 'Admin') {
                localStorage.setItem('isAdmin', 'true');
                localStorage.setItem('lastActivity', Date.now().toString());
                window.location.replace('/admin');
            } else {
                localStorage.removeItem('isAdmin');
                localStorage.removeItem('lastActivity');
                navigate('/');
            }
        } catch (err) {
            console.error('Login error:', err);
            setError(isRtl ? 'حدث خطأ في تسجيل الدخول. يرجى التحقق من بياناتك.' : 'Login failed. Please check your credentials.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="auth-page" dir={isRtl ? 'rtl' : 'ltr'}>
            <div className="auth-form-side">
                <div className="auth-form-container">
                    <div className="auth-header">
                        <h1>{t('auth.loginTitle')}</h1>
                        <p className="auth-subtitle">{t('auth.loginSubtitle')}</p>
                    </div>

                    <form className="auth-form" onSubmit={handleSubmit}>
                        <div className="input-group">
                            <label>{t('auth.emailLabel')}</label>
                            <input
                                type="email"
                                placeholder="name@example.com"
                                value={formData.email}
                                onChange={(e) => setFormData({ ...formData, email: e.target.value.replace(/\s/g, '') })}
                                onKeyDown={(e) => { if (e.key === ' ') e.preventDefault(); }}
                                onBlur={(e) => setFormData({ ...formData, email: e.target.value.replace(/\s/g, '') })}
                                required
                            />
                        </div>

                        <div className="input-group">
                            <div className="input-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <label>{t('auth.passwordLabel')}</label>
                            </div>
                            <input
                                type="password"
                                placeholder="••••••••"
                                value={formData.password}
                                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                                required
                            />
                        </div>

                        <div className="auth-extras">
                            <label className="remember-me">
                                <input type="checkbox" />
                                <span>{t('auth.rememberMe')}</span>
                            </label>
                        </div>

                        {error && <div className="auth-error-message" style={{ color: '#ef4444', backgroundColor: '#fee2e2', padding: '12px', borderRadius: '8px', marginBottom: '20px', fontSize: '0.9rem', textAlign: 'center' }}>{error}</div>}

                        <button type="submit" className="btn-auth-primary" disabled={isLoading}>
                            {isLoading ? (isRtl ? 'جاري التحميل...' : 'Loading...') : t('auth.loginBtn')}
                        </button>
                    </form>
                </div>
            </div>

            <div className="auth-image-side">
                <img src={require("../assets/hero-bg.webp")} alt="Auth background" />
                <div className="auth-overlay">
                    <div className="overlay-content">
                        <div className="overlay-logo">AYONK</div>
                        <h2 className="overlay-quote">
                            {isRtl
                                ? 'نبني المستقبل، ونقود الابتكار في كل مشروع.'
                                : 'Building the future, leading innovation in every project.'
                            }
                        </h2>
                    </div>
                </div>
            </div>
        </div>
    );
}
